module.exports = __webpack_public_path__ + "img/belfius.448c9840.svg";